import { roundDecimals } from './round-decimals.ts';

const CATALOG_GROSS_TAX_PERCENT = 19;
const GROSS_VAT_FACTOR = 1 + CATALOG_GROSS_TAX_PERCENT / 100;
const LONG_TERM_DAYS = 30;

export function scaleCatalogGrossAmount(
  amount: number,
  taxPercent: number = CATALOG_GROSS_TAX_PERCENT,
): number {
  if (taxPercent === CATALOG_GROSS_TAX_PERCENT) {
    return amount;
  }
  return roundDecimals((amount * (1 + taxPercent / 100)) / GROSS_VAT_FACTOR, 2);
}

function extraOptionFromDay(entry: { fromDay?: number; pricePerDay: number }): number {
  return entry.fromDay ?? Number.POSITIVE_INFINITY;
}

export function extraOptionPriceForDays(
  option: {
    pricingType?: string | null;
    price?: number | null;
    pricePerDay?: { fromDay?: number; pricePerDay: number }[] | null;
    calculatedPrice?: number | null;
  },
  days: number,
): number {
  const step = (option.pricePerDay ?? [])
    .filter((entry) => extraOptionFromDay(entry) <= days)
    .sort((a, b) => extraOptionFromDay(b) - extraOptionFromDay(a))[0];
  if (option.pricingType !== 'FIXED' && step) {
    return roundDecimals(step.pricePerDay * days, 2);
  }
  if (option.pricingType === 'FIXED' || option.price != null) {
    return option.price ?? 0;
  }
  return option.calculatedPrice ?? 0;
}

/** Reprice a catalog extra. LTR uses the 30-day band then remaining/30 for per-day extras. */
export function periodExtraOptionPrice(
  option: Parameters<typeof extraOptionPriceForDays>[0],
  days: number,
  taxPercent: number | null | undefined,
  longTerm = false,
): number {
  const pricedDays = longTerm ? LONG_TERM_DAYS : days;
  const thirtyDay = scaleCatalogGrossAmount(
    extraOptionPriceForDays(option, pricedDays),
    taxPercent ?? CATALOG_GROSS_TAX_PERCENT,
  );
  if (!longTerm || option.pricingType === 'FIXED' || days === LONG_TERM_DAYS) {
    return thirtyDay;
  }
  return roundDecimals((thirtyDay / LONG_TERM_DAYS) * days, 2);
}
